<div class="vertical-container">
    <h1 style="font: 600 28px 'Poppins', sans-serif; max-width: 500px; text-align: center;">Dogo is built with all-in-one approach</h1>
    <br>
    <br>
    <div class="concept-container horizontal-container">
        <div class="concept-video-container">
            <img src="assets/images/video-img.png" alt="Dogo Concept Video" />
            <div class="concept-video-play-button-wave-2">
                <div class="concept-video-play-button-wave-1">
                    <i class="concept-video-play-button fa fa-play"></i>
                </div>
            </div>
        </div>
        <span style="width: 64px; height: 64px;"></span>
        <div class="concept-info-container">
            <h1>Dogo will revolutionize the way you do things</h1>
            <br>
            <p>Dogo is the first app to harness the power of professionals in your locality and enable you to get things done by them. It has all-in-one approach will make your life way more easier</p>
        </div>
    </div>
</div>